export default {"src":"/_next/static/media/arrowRight.ae5f6b0c.svg","height":24,"width":23,"blurWidth":0,"blurHeight":0};